export const PHONE_DISPLAY = "0424 817 555";
export const PHONE_TEL = "tel:+61424817555";
export const ADDRESS_1 = "2A/75 Fitzroy St, St Kilda VIC 3182";
export const ADDRESS_2 = "Entrance via Jackson St";
export const MAPS_URL =
  "https://www.google.com/maps/place/?q=place_id:ChIJE1Iu5G5o1moRiX9RPgsAidc";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Oliver%27s%20Barber%20Shop%2C%202A%2F75%20Fitzroy%20St%2C%20St%20Kilda%20VIC%203182&z=16&output=embed";
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/?q=place_id:ChIJE1Iu5G5o1moRiX9RPgsAidc";
export const REVIEW_WRITE_URL =
  "https://search.google.com/local/writereview?placeid=ChIJE1Iu5G5o1moRiX9RPgsAidc";
export const INSTAGRAM_URL = "https://www.instagram.com/oliversbarbershop/";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  { name: "HAIRCUT", desc: "The standard. Sharp, clean, done right.", price: "$40" },
  { name: "ZERO FADE", desc: "Taken down to zero. Clean as it gets.", price: "$45" },
  { name: "SKIN FADE", desc: "Sharp fade. Clean finish.", price: "$48" },
  { name: "BUZZ CUT", desc: "Short, tight, no fuss.", price: "FROM $25" },
  { name: "HEAD SHAVE", desc: "Smooth up top, proper finish.", price: "$38" },
  { name: "BEARD SHAVE", desc: "Hot towel, cut-throat, old school.", price: "$35" },
  { name: "BEARD TRIM", desc: "With line up. Shape it, clean it up.", price: "$30" },
  { name: "SENIOR", desc: "Mates' rates for the old boys.", price: "$25–35", note: "Mon–Thu only" },
  { name: "SKIN FADE + BEARD", desc: "The full works in one session.", price: "$70", note: "Special offer" },
  { name: "HAIRCUT + BEARD", desc: "Hair and beard sorted together.", price: "$65" },
  { name: "TODDLER", desc: "First cuts, zero drama.", price: "$30" },
  { name: "SCHOOL KIDS CUT", desc: "Fresh cuts for the younger crew.", price: "$35–40" },
  { name: "ART DESIGN", desc: "Freestyle patterns, lines and logos.", price: "FROM $30" },
  { name: "MOHAWK", desc: "Stand up. Stand out.", price: "FROM $45" },
  { name: "SCISSORS CUT", desc: "Old-school scissor work.", price: "FROM $45" },
];

const u = (id, w = 900) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;
const p = (id, w = 900) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const HERO_IMG = u("photo-1635273051839-003bf06a8751", 1400);
export const ABOUT_IMG = "/photos/interior.jpg";

export const GALLERY = [
  { src: "/photos/mural.jpg", tag: "JACKSON ST", alt: "Street art mural and Oliver's Barber Shop sign on Jackson St", ratio: "aspect-[4/3]" },
  { src: "/photos/shopfront.jpg", tag: "FITZROY ST", alt: "Oliver's Barber Shop shopfront on Fitzroy St, St Kilda", ratio: "aspect-square" },
  { src: "/photos/vibes.jpg", tag: "GOOD VIBES", alt: "Barber and smiling client mid-cut, rainbow crossing outside", ratio: "aspect-[3/4]" },
  { src: "/photos/tools.jpg", tag: "TOOLS", alt: "Vintage Singer machine and barber tools inside Oliver's Barber Shop", ratio: "aspect-[3/4]" },
  { src: "/photos/window.jpg", tag: "OPEN", alt: "Oliver's Barber Shop front window, barber chair and checkered floor", ratio: "aspect-[4/3]" },
  { src: "/photos/detail.jpg", tag: "FRESH", alt: "Detailed trim work by the front window", ratio: "aspect-[3/4]" },
  { src: "/photos/streetpole.jpg", tag: "THE STRIP", alt: "Barber pole and BARBER lettering outside the shop", ratio: "aspect-[4/3]" },
  { src: "/photos/design.jpg", tag: "PATTERN", alt: "Freestyle shaved pattern haircut at Oliver's Barber Shop", ratio: "aspect-[3/4]" },
];

export const REVIEWS = [
  {
    quote: "Best fade I've had in ages. Proper attention to detail.",
    author: "LOCAL LEGEND",
  },
  {
    quote: "Great barber, great atmosphere, great cut. Simple.",
    author: "ST KILDA REGULAR",
  },
  {
    quote: "Found my new barber. Won't be going anywhere else.",
    author: "WALK-IN, NOW REGULAR",
  },
];

export const btnInk =
  "inline-flex items-center justify-center gap-2 border-2 border-ink bg-ink px-7 py-4 font-display text-lg uppercase tracking-wide text-paper shadow-hard-rust transition-transform duration-150 hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-none";
export const btnLine =
  "inline-flex items-center justify-center gap-2 border-2 border-ink bg-transparent px-7 py-4 font-display text-lg uppercase tracking-wide text-ink shadow-hard-sm transition-all duration-150 hover:bg-ink hover:text-paper";
export const btnRust =
  "inline-flex items-center justify-center gap-2 border-2 border-ink bg-rust px-7 py-4 font-display text-lg uppercase tracking-wide text-paper shadow-hard transition-transform duration-150 hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-none";
